import React from "react";
import { PdfIcon } from "../../../Assets/userProfile/userProfile";
import toast from "react-hot-toast";
import { FiCopy } from "react-icons/fi";

const CustomersInformation = ({ profileData, setPrintStart }) => {
  // console.log(profileData);

  const handleCopy = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast.success("Link copied to clipboard");
      })
      .catch((error) => {
        toast.error("Failed to copy link");
        console.error("Copy error: ", error);
      });
  };
  return (
    <div>
      {/* Top Nav */}
      <div className="flex items-center justify-between">
        <h1 className="py-8 pb-[10px] font-inter  text-[23px] font-semibold leading-[44.8px] text-secondBlack md:pb-[20px] md:text-[26px] lg:py-8">
          Customers Information
        </h1>
        <div className="responsive-svg flex items-center">
          <button
            className="flex items-center"
            onClick={() => setPrintStart(true)}
          >
            <PdfIcon></PdfIcon>
            <p className="hidden font-poppins text-[20px] font-medium leading-[44.8px]  text-[#568BEC] md:flex">
              Document
            </p>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-[20px] pb-[10px] md:grid-cols-2 md:pb-[20px] lg:grid-cols-3 lg:gap-6 lg:pb-8">
        <div>
          <h3 className="font-inter text-[18px] font-medium leading-[29.05px] text-secondBlack md:text-[21px]">
            Full Name
          </h3>
          <div className="mt-[8px] flex min-h-[50px] items-center rounded-lg border px-[16px] font-inter text-[18px] font-normal capitalize  leading-[29.05px] text-secondBlack shadow-smallShadow md:text-[21px]">
            {profileData?.full_name || (
              <span className="text-[18px] text-gray-400">N/A</span>
            )}
          </div>
        </div>
        <div>
          <h3 className="font-inter text-[18px] font-medium  leading-[29.05px] text-secondBlack md:text-[21px]">
            Date Of Birth
          </h3>
          <div className="mt-[8px] flex min-h-[50px]  items-center rounded-lg border px-[16px] font-inter text-[18px] font-normal capitalize  leading-[29.05px] text-secondBlack shadow-smallShadow md:text-[21px]">
            {profileData?.birth_date || (
              <span className="text-[18px] text-gray-400">N/A</span>
            )}
          </div>
        </div>
        <div>
          <h3 className="font-inter text-[18px] font-medium  leading-[29.05px] text-secondBlack md:text-[21px]">
            Age
          </h3>
          <div className="mt-[8px] flex min-h-[50px]  items-center rounded-lg border px-[16px] font-inter text-[18px] font-normal capitalize  leading-[29.05px] text-secondBlack shadow-smallShadow md:text-[21px]">
            {profileData?.age || (
              <span className="text-[18px] text-gray-400">N/A</span>
            )}
          </div>
        </div>
        <div>
          <h3 className="font-inter text-[18px] font-medium capitalize  leading-[29.05px] text-secondBlack md:text-[21px]">
            Gender
          </h3>
          <div className="mt-[8px] flex min-h-[50px]  items-center rounded-lg border px-[16px] font-inter text-[18px] font-normal capitalize  leading-[29.05px] text-secondBlack shadow-smallShadow md:text-[21px]">
            {profileData?.gender || (
              <span className="text-[18px] text-gray-400">N/A</span>
            )}
          </div>
        </div>
        <div>
          <h3 className="font-inter text-[18px] font-medium  leading-[29.05px] text-secondBlack md:text-[21px]">
            Blood Group
          </h3>
          <div className="mt-[8px] flex  min-h-[50px] items-center rounded-lg border px-[16px] font-inter text-[18px] font-normal  leading-[29.05px] text-secondBlack shadow-smallShadow md:text-[21px]">
            {profileData?.blood_group || (
              <span className="text-[18px] text-gray-400">N/A</span>
            )}
          </div>
        </div>
        <div>
          <h3 className="font-inter text-[18px] font-medium  leading-[29.05px] text-secondBlack md:text-[21px]">
            Pan Number
          </h3>
          <div
            onClick={() => handleCopy(profileData?.mobile_no)}
            className="mt-[8px] flex  min-h-[50px] items-center justify-between rounded-lg border px-[16px] font-inter text-[18px] font-normal  leading-[29.05px] text-secondBlack shadow-smallShadow md:text-[21px]"
          >
            {profileData?.card_no || (
              <span className="text-[18px] text-gray-400">N/A</span>
            )}
            <FiCopy className="h-5 w-5" />
          </div>
        </div>
        <div>
          <h3 className="font-inter text-[18px] font-medium  leading-[29.05px] text-secondBlack md:text-[21px]">
            Phone Number
          </h3>
          <div className="mt-[8px] flex  min-h-[50px] items-center justify-between rounded-lg border px-[16px] font-inter text-[18px] font-normal  leading-[29.05px] text-secondBlack shadow-smallShadow md:text-[21px]">
            {}
            {profileData?.mobile_code && profileData?.mobile_no ? (
              <>
                <div onClick={() => handleCopy(profileData?.mobile_no)}>
                  {profileData?.mobile_code}
                  {profileData?.mobile_no}
                </div>
                <FiCopy className="h-5 w-5" />
              </>
            ) : (
              <span className="text-[18px] text-gray-400">N/A</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomersInformation;
